import { useSessionStore } from "@/sdk/sessions/session.store";

import type { ChatTask } from "./chatTask";

import { isChatTask } from "./typeGuards";

/*
TODO:// The code below is a temporary hack as a result of completed tasks still being saved into state
// + all kind of weird immerable behavior (draft of tasks that create additional instances of the same task in state change edge-cases)
// ITS TEMPORARY so we can continue working on the wire-frame and add selected chat and chats in queue functionality,
// but should be really fixed in Zustand level or perhaps in TwilioTask level.
// We're working to fix it, promise 😔)
*/
export function useChatTasks(): ChatTask[] {
    const sessions = useSessionStore((state) => state.sessions);
    const duplicatedChatTasks = sessions.flatMap<ChatTask>((s) =>
        Array.from(s.tasks.values())
            .filter((task) => !["completed", "cancelled"].includes(task.status))
            .filter((task) => isChatTask(task)),
    );

    // Again need to dedupe tasks bc the sessionsOrchestrator is 💩
    // TODO:// Problem initiate from the following code lines:
    // https://github.com/Soluto-Private/expert-workspace/blob/main/apps/expert-ui/src/sdk/sessions/sessionsOrchestrator.ts#L335-L347
    // Real fixes are needed instead of this workaround, but it's too risky at the moment:
    // 1. Convert the store `Sessions` to `Map` type, like we did with `Task`.
    // 2. Change the above lines in `sessionsOrchestrator` to check `isVoiceTask` before assuming that another task need to be added to the store
    const chatTasks = [...new Map(duplicatedChatTasks.map((task) => [task.id, task])).values()];
    return chatTasks;
}
